
<script setup>

  import AudioPlayer from '../components/audio-player.vue';

  import audio_s1e0_000_130 from '../audio/s1e0_000_130.mp3';

  import track_s1e0_000_130 from '../audio/s1e0_000_130.vtt';

  import audio_s1e1_740_850 from '../audio/s1e1_740_850.mp3';

  import track_s1e1_740_850 from '../audio/s1e1_740_850.vtt';

</script>

<template>

  <img class="block w-full max-w-[200px] mx-auto" src="../images/activity-2-part-1-book.png" alt="Green Book, 1936 Edition" />

  <p class="mt-6 text-neutral-700">
    
    In 1936, Victor Hugo Green began publishing the <em>Negro Motorist Green Book</em>,
    
    a series of annual travel guides that were essential in helping African Americans travel through a segregated America.
    
    You'll need to know where the safe spaces are as you make the journey to Shenandoah National Park.
  
  </p>

  <p class="mt-6 font-semibold text-neutral-700">

    At any time during this activity, you can look at The Green Book by clicking the
    
    "View Green Book" tab at the top right-hand corner of the screen.

  </p>

  <div class="mt-6">

    <AudioPlayer :src="audio_s1e0_000_130" :track="track_s1e0_000_130" />

    <div class="mt-3 text-xs italic">Source: Driving the Green Book - Macmillan Podcasts - S1:E0</div>

  </div>

  <div class="mt-6">

    <AudioPlayer :src="audio_s1e1_740_850" :track="track_s1e1_740_850" />
  
    <div class="mt-3 text-xs italic">Source: Driving the Green Book - Macmillan Podcasts - S1:E1</div>

  </div>

</template>
